export const selectedProductStorageKey = 'entity_portal_selected_product_id';
export const selectedProductQueryParam = 'product';
export const portalEntityId = 'portal';
